
export default function TestimonialsSection() {
  const testimonials = [
    {
      name: 'Jennifer Martinez',
      role: 'Parent of Emma (Age 8)',
      content: 'Emma has grown so much in confidence since joining NextZen. The coaches are amazing with kids and really focus on making soccer fun while teaching proper techniques.',
      rating: 5,
      image: 'https://public.readdy.ai/ai/img_res/0142e624180ee69c3fa68f835dbae4a3.jpg'
    },
    {
      name: 'Robert Chen',
      role: 'Parent of Alex (Age 12)',
      content: 'The structured training program has helped Alex develop not just soccer skills but also teamwork and leadership qualities. Highly recommend NextZen!',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=Professional%20father%20in%20his%2040s%2C%20confident%20smile%2C%20business%20casual%20attire%2C%20outdoor%20background%2C%20trustworthy%20appearance&width=80&height=80&seq=parent-robert&orientation=squarish'
    },
    {
      name: 'Lisa Johnson',
      role: 'Parent of twins Jake & Luke (Age 10)',
      content: 'Both my boys love coming to practice. The coaches do an excellent job of keeping all the kids engaged and motivated. Great value for the quality of coaching.',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=Cheerful%20mother%20in%20her%20late%2030s%2C%20bright%20smile%2C%20sporty%20casual%20clothing%2C%20outdoor%20setting%2C%20energetic%20and%20positive%20demeanor&width=80&height=80&seq=parent-lisa&orientation=squarish'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">What Parents Say</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Don't just take our word for it - hear from the families who trust us with their children's development.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-gray-50 rounded-2xl p-8 hover:shadow-lg transition-shadow duration-300">
              <div className="flex items-center mb-4">
                {[...Array(testimonial.rating)].map((_, starIndex) => (
                  <i key={starIndex} className="ri-star-fill text-yellow-400 text-lg"></i>
                ))}
              </div>
              
              <p className="text-gray-700 mb-6 italic">
                "{testimonial.content}"
              </p>
              
              <div className="flex items-center">
                <img
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-12 h-12 rounded-full object-cover object-top mr-4"
                />
                <div>
                  <h4 className="font-semibold text-gray-900">{testimonial.name}</h4>
                  <p className="text-sm text-gray-600">{testimonial.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <div className="bg-blue-50 rounded-2xl p-8 max-w-4xl mx-auto">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Join Our Soccer Family</h3>
            <p className="text-gray-600 mb-6">
              Over 500 families trust NextZen Soccer Academy for their children's development. 
              See why we're the top choice for youth soccer in the area.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <div className="text-center">
                <div className="text-3xl font-bold text-blue-600">500+</div>
                <div className="text-sm text-gray-600">Happy Families</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-green-600">8</div>
                <div className="text-sm text-gray-600">Years Experience</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-purple-600">95%</div>
                <div className="text-sm text-gray-600">Satisfaction Rate</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
